import React from 'react'
function CTA() {
  return (
    <div className='cta'>
      <a href="/Assets/Amaan_Siddiqui_Resume.pdf" download className='btn'>Download CV</a>
      <a href='#footer' className='btn btn-primary'>Let's Connect</a>
    </div>
  )
}

export default CTA
